// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: var(--navbar-bg);
  box-shadow: var(--shadow-md);
  z-index: 1000;
  border-bottom: 1px solid var(--navbar-border);
  transition: background 0.25s ease, border-color 0.25s ease;
}

.navbar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 24px 0 60px;
  max-width: 100%;
}

.navbar-left {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.navbar-menu-btn {
  display: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface-2);
  color: var(--text);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.navbar-menu-btn:hover {
  background: var(--surface-hover);
  border-color: var(--border-strong);
}

.navbar-menu-btn:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.navbar-right {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
}

.navbar-center {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 0;
  padding: 0 12px;
}

.navbar-title {
  color: var(--text);
  font-size: 2.2rem;
  font-weight: 700;
  margin: 0;
  text-align: center;
  letter-spacing: -0.025em;
}

.navbar-logo-left {
  width: 170px;
  height: 100px;
  object-fit: contain;
  filter: none;
}

.navbar-logo-right {
  width: 150px;
  height: 70px;
  object-fit: contain;
  filter: none;
}

/* User menu - top right */
.navbar-user-menu {
  position: relative;
}

.navbar-user-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.9375rem;
  font-weight: 500;
  color: var(--text);
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.navbar-user-trigger:hover {
  background: var(--surface-hover);
  border-color: var(--border-strong);
}

.navbar-user-trigger:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.navbar-user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--surface-3);
  color: var(--text-muted);
}

.navbar-user-name {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.navbar-user-chevron {
  color: var(--text-muted);
  transition: transform 0.2s ease;
}

.navbar-user-chevron.open {
  transform: rotate(180deg);
}

.navbar-user-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 220px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--shadow-lg);
  padding: 8px 0;
  z-index: 1001;
}

.navbar-user-dropdown-header {
  padding: 10px 14px;
  border-bottom: 1px solid var(--divider);
}

.navbar-user-dropdown-email {
  font-size: 0.8125rem;
  color: var(--text-muted);
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.navbar-user-dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: none;
  font-size: 0.9375rem;
  color: var(--text);
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease;
}

.navbar-user-dropdown-item:hover {
  background: var(--surface-hover);
}

.navbar-user-dropdown-item.logout {
  color: var(--danger);
}

.navbar-user-dropdown-item.logout:hover {
  background: var(--danger-soft);
}

/* Responsive design — desktop styles above stay unchanged */
@media (max-width: 768px) {
  .top-navbar {
    height: 64px;
    padding-top: env(safe-area-inset-top);
  }

  .navbar-menu-btn {
    display: inline-flex;
  }

  .navbar-title {
    font-size: 1.2rem;
  }

  .navbar-logo-left {
    width: 72px;
    height: 40px;
  }

  .navbar-logo-right {
    width: 72px;
    height: 36px;
  }

  .navbar-content {
    padding: 0 12px;
    gap: 8px;
  }

  .navbar-left {
    gap: 8px;
  }

  .navbar-right {
    gap: 8px;
    min-width: 0;
  }

  .navbar-user-trigger {
    padding: 6px 8px;
    gap: 6px;
  }

  .navbar-user-avatar {
    width: 32px;
    height: 32px;
  }

  .navbar-user-name {
    display: none;
  }

  .navbar-user-chevron {
    display: none;
  }

  .theme-toggle-label {
    display: none;
  }

  .navbar-user-dropdown {
    right: 0;
    min-width: min(220px, calc(100vw - 24px));
  }
}

@media (max-width: 480px) {
  .navbar-logo-right {
    display: none;
  }

  .navbar-logo-left {
    width: 64px;
    height: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,aAAa;EACb,6CAA6C;EAC7C,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,8EAA8E;AAChF;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,4DAA4D;AAC5D;EACE;IACE,YAAY;IACZ,qCAAqC;EACvC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".top-navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 80px;\n  background: var(--navbar-bg);\n  box-shadow: var(--shadow-md);\n  z-index: 1000;\n  border-bottom: 1px solid var(--navbar-border);\n  transition: background 0.25s ease, border-color 0.25s ease;\n}\n\n.navbar-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n  padding: 0 24px 0 60px;\n  max-width: 100%;\n}\n\n.navbar-left {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.navbar-menu-btn {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--surface-2);\n  color: var(--text);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.navbar-menu-btn:hover {\n  background: var(--surface-hover);\n  border-color: var(--border-strong);\n}\n\n.navbar-menu-btn:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n.navbar-right {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.navbar-center {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 0;\n  padding: 0 12px;\n}\n\n.navbar-title {\n  color: var(--text);\n  font-size: 2.2rem;\n  font-weight: 700;\n  margin: 0;\n  text-align: center;\n  letter-spacing: -0.025em;\n}\n\n.navbar-logo-left {\n  width: 170px;\n  height: 100px;\n  object-fit: contain;\n  filter: none;\n}\n\n.navbar-logo-right {\n  width: 150px;\n  height: 70px;\n  object-fit: contain;\n  filter: none;\n}\n\n/* User menu - top right */\n.navbar-user-menu {\n  position: relative;\n}\n\n.navbar-user-trigger {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 0.9375rem;\n  font-weight: 500;\n  color: var(--text);\n  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.navbar-user-trigger:hover {\n  background: var(--surface-hover);\n  border-color: var(--border-strong);\n}\n\n.navbar-user-trigger:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n.navbar-user-avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--surface-3);\n  color: var(--text-muted);\n}\n\n.navbar-user-name {\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.navbar-user-chevron {\n  color: var(--text-muted);\n  transition: transform 0.2s ease;\n}\n\n.navbar-user-chevron.open {\n  transform: rotate(180deg);\n}\n\n.navbar-user-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 220px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: var(--shadow-lg);\n  padding: 8px 0;\n  z-index: 1001;\n}\n\n.navbar-user-dropdown-header {\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--divider);\n}\n\n.navbar-user-dropdown-email {\n  font-size: 0.8125rem;\n  color: var(--text-muted);\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.navbar-user-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 14px;\n  border: none;\n  background: none;\n  font-size: 0.9375rem;\n  color: var(--text);\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.15s ease;\n}\n\n.navbar-user-dropdown-item:hover {\n  background: var(--surface-hover);\n}\n\n.navbar-user-dropdown-item.logout {\n  color: var(--danger);\n}\n\n.navbar-user-dropdown-item.logout:hover {\n  background: var(--danger-soft);\n}\n\n/* Responsive design — desktop styles above stay unchanged */\n@media (max-width: 768px) {\n  .top-navbar {\n    height: 64px;\n    padding-top: env(safe-area-inset-top);\n  }\n\n  .navbar-menu-btn {\n    display: inline-flex;\n  }\n\n  .navbar-title {\n    font-size: 1.2rem;\n  }\n\n  .navbar-logo-left {\n    width: 72px;\n    height: 40px;\n  }\n\n  .navbar-logo-right {\n    width: 72px;\n    height: 36px;\n  }\n\n  .navbar-content {\n    padding: 0 12px;\n    gap: 8px;\n  }\n\n  .navbar-left {\n    gap: 8px;\n  }\n\n  .navbar-right {\n    gap: 8px;\n    min-width: 0;\n  }\n\n  .navbar-user-trigger {\n    padding: 6px 8px;\n    gap: 6px;\n  }\n\n  .navbar-user-avatar {\n    width: 32px;\n    height: 32px;\n  }\n\n  .navbar-user-name {\n    display: none;\n  }\n\n  .navbar-user-chevron {\n    display: none;\n  }\n\n  .theme-toggle-label {\n    display: none;\n  }\n\n  .navbar-user-dropdown {\n    right: 0;\n    min-width: min(220px, calc(100vw - 24px));\n  }\n}\n\n@media (max-width: 480px) {\n  .navbar-logo-right {\n    display: none;\n  }\n\n  .navbar-logo-left {\n    width: 64px;\n    height: 36px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
